export default "__VITE_ASSET__D7RU_X6n__"